export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getFormBuilderListlAction";
    Actions["GET_DETAIL"] = "getFormBuilderDetailAction";
    Actions["POST_DATA"] = "postFormBuilderAction";
    Actions["UPDATE_DATA"] = "putFormBuilderAction";
    Actions["DELETE_DATA"] = "deleteFormBuilderAction";
    Actions["GET_CODE_LIST"] = "getFormBuilderCodeListAction";
    Actions["GET_TYPE_LIST"] = "getFormBuilderTypeListAction";
    Actions["GET_METHOD_LIST"] = "getFormBuilderMethodListAction";
    Actions["GET_FIELD_TYPE_LIST"] = "getFormBuilderFieldTypeListAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_ORDER"] = "setFormBuilderListOrderByMutation";
    Mutations["SET_FORM_BUILDER_LIST"] = "setFormBuilderListMutation";
    Mutations["SET_FORM_BUILDER_LIST_LOADING"] = "setFormBuilderListLoadingMutation";
    Mutations["SET_FORM_BUILDER_LIST_PAGINATION"] = "setFormBuilderListPaginationMutation";
    Mutations["SET_FILTER"] = "setFormBuilderListFilter";
    Mutations["CLEAR_FILTER"] = "clearFormBuilderListFilter";
})(Mutations || (Mutations = {}));
export var FieldType;
(function (FieldType) {
    FieldType["CheckBox"] = "Check Box";
    FieldType["Header"] = "Header";
    FieldType["RadioButton"] = "Radio Button";
    FieldType["Scheme"] = "Scheme";
    FieldType["Sign"] = "Sign";
    FieldType["Table"] = "Table";
    FieldType["Text"] = "Text";
    FieldType["TextArea"] = "Text Area";
    FieldType["Upload"] = "Upload";
    FieldType["Select"] = "Select";
    FieldType["SubHeader"] = "Sub Header";
    FieldType["DatePicker"] = "Date Picker";
})(FieldType || (FieldType = {}));
